import React, { useEffect, useRef, useState } from 'react';
import './next-day-delivery-count-down-timer.scss';

const h = 60 * 60 * 1000;
const s = 1000;

const NextDayDeliveryCountDownTimerContainer = () => {
  if (!window.nextDayDeliveryCountDownTimer || window.nextDayDeliveryCountDownTimer.endTime + s < Date.now()) {
    return null;
  }

  const { endTime, textBeforeCutOff, textAfterCutOff } = window.nextDayDeliveryCountDownTimer || {};
  return (
    <NextDayDeliveryCountDownTimer
      endTime={endTime}
      textAfterCutOff={textAfterCutOff}
      textBeforeCutOff={textBeforeCutOff}
    />
  );
};

const NextDayDeliveryCountDownTimer = ({ endTime, textBeforeCutOff, textAfterCutOff }) => {
  const interval = useRef(null);
  const ms = useRef(endTime - Date.now());
  const timeRef = useRef(null);
  const [time] = useState('00:00:00');
  const [isHidden, setIsHidden] = useState(false);

  useEffect(() => {
    if (timeRef.current) {
      const countdown = () => {
        interval.current = setInterval(() => {
          ms.current -= s;

          const hh = ms.current / h;
          const hours = Math.floor(hh);
          const mm = (hh % 1) * 60;
          const minutes = Math.floor(mm);
          const seconds = Math.floor((mm % 1) * 60);
          const timeText = `${hours > 9 ? hours : `0${hours}`}:${minutes > 9 ? minutes : `0${minutes}`}:${
            seconds > 9 ? seconds : `0${seconds}`
          }`;

          timeRef.current.textContent = timeText;

          if (ms.current < s) {
            clearInterval(interval.current);
            setIsHidden(true);
          }
        }, s);
      };

      countdown();
    }

    return () => {
      clearInterval(interval.current);
    };
  }, []);

  return isHidden ? null : (
    <section id="cms-delivery-countdown" className="cms-delivery-countdown">
      <div className="cms-delivery-countdown__icon">
        <img src="/assets/images/stopwatch.svg" role="presentation" className="" alt="timer" />
      </div>
      <div className="cms-delivery-countdown__text">
        <span>{textBeforeCutOff} </span>
        <time ref={timeRef} className="cms-delivery-countdown__time">
          {time}
        </time>
        <span> {textAfterCutOff}</span>
      </div>
    </section>
  );
};

export default NextDayDeliveryCountDownTimerContainer;
